import { gql } from '@apollo/client';

export * from './agreementUpdate.mutation.generated';

export const AGREEMENT_UPDATE = gql`
  mutation agreementUpdate($escrowId: ID!, $agreementParams: AgreementUpdateParams!) {
    agreementUpdate(input: { escrowId: $escrowId, agreementParams: $agreementParams }) {
      success
      errors
      escrow {
        id
        agreementSettingsConfigured
        agreement {
          ...EscrowAgreementFields
          protectionPeriod
        }
      }
    }
  }
`;
